import _ from 'underscore';
import InlineComponent from './inlineComponent.jsx';
import Timezone from '../../../components/Timezone.jsx';

module.exports = class TimezoneRenderer extends InlineComponent {
  define() {
    let zones = _.isEmpty(this.element.data('timezone'))
      ? 'user'
      : this.element.data('timezone');

    this.component = Timezone;
    this.data = {
      identifier: this.element.data('identifier'),
      format: this.element.data('format') || 'dddd, MMMM Do YYYY, h:mm:ss a z',
      labels: this.element.data('labels') || [],
      date: this.element.text().trim(),
      zones:
        typeof zones === 'string' ? [zones.trim()] : zones.map((i) => i.trim()),
    };
  }
};
